export function formatIBAN(candidate: string): string {
  return candidate.replace(/[^\dA-Z]/g, '').replace(/(.{4})/g, '$1 ').trim();
}
